<template>
<DashBoardLayout :showNavbar=true :isSearch=false > 
<div class="w100">

    <Products :selecetdCatg="selecetdCatgText" :headingText="headingText"></Products> 
 
</div>
</DashBoardLayout>
</template>


<script>
import DashBoardLayout from '../../layouts/DashboardLayout.vue'
import globalMixins from '../globalMixins';
import Products from './../RecyclerView'

export default {
    components: {
        Products,DashBoardLayout
    },
    name: 'Wishlist',
    mixins: [globalMixins],
    // created(){
    //     this.$emit(`update:layout`,DashBoardLayout)
    // },
    data() {
        return {
            selecetdCatgText :'All',
            headingText: "Wishlist",
            buttonClicked: true,
            navBarValue : true,
            buttons: [{
                    text: 'Wishlist',
                    state: 'activeTab',
                }

            ],
        }
    },
    mounted(){
        this.checkSession();
    },
    methods: {

    },
}
</script>
